import { createGettext as _createGettext } from 'vue3-gettext'
import { LANGUAGES, DEFAULT_LANGUAGE } from '@src/constants'
import translations from '@src/translations.json'

export function selectBestLanguage (browserLangs, supportedLangs, defaultLang) {
  if (browserLangs.length) {
    for (const lang of browserLangs) {
      const parts = lang.toLowerCase().split('-')
      if (parts.length > 1) {
        parts[1] = parts[1].toUpperCase()
      }
      const normLang = parts.join('-')
      if (supportedLangs.includes(normLang)) {
        return normLang
      } else if (parts.length > 1 && supportedLangs.includes(parts[0])) {
        return parts[0]
      }
    }
    return defaultLang
  } else {
    return defaultLang
  }
}

export function getLanguageMixin() {
  return {
    methods: {
      $selectBestLanguage: selectBestLanguage,
    },
  }
}

export function getVuetifyLocaleObject(localeMessages) {
  const bestLanguage = selectBestLanguage(
    navigator.languages,
    Object.keys(LANGUAGES),
    DEFAULT_LANGUAGE,
  )
  return {
    messages: Object.assign(
      { translations },
      ...Object.keys(LANGUAGES).map(lang => ({ [lang]: localeMessages[lang] })),
    ),
    fallback: DEFAULT_LANGUAGE,
    locale: bestLanguage,
  }
}

export function createGettext() {
  const bestLanguage = selectBestLanguage(
    navigator.languages,
    Object.keys(LANGUAGES),
    DEFAULT_LANGUAGE,
  )
  return _createGettext({
    availableLanguages: LANGUAGES,
    defaultLanguage: bestLanguage,
    translations,
    silent: true,
  })
}
